const FormMode = {
  View: "view",
  Edit: "edit",
  Add: "add",
};

export default FormMode;
